module.exports = __webpack_public_path__ + "img/vip-crowd_cclub_1000.7c7c62cc.png";